import defineActionTypes from 'utils/defineActionTypes';

// Define action types
export default defineActionTypes('auth', ['SET_AUTH', 'SET_ROLES', 'REMOVE_AUTH']);
